import React, { Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Form } from "reactstrap";
import {
  FileInputField,
  InputField,
  MonthInputField,
  SelectionField,
  TextAreaField,
} from "../../../CommonElements";
import { useSlipGaji } from "../../../Context/SlipGajiContext";
import { useDokumen } from "../../../Context/DokumenContext";

const FormSlipGaji = ({ setMode, setData, pending, setPending }) => {
  const slipGajiAPI = useSlipGaji();
  const dokumenAPI = useDokumen();
  const getCurrentMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      keperluan: "",
      slip_gaji_untuk: "",
      file_gaji: "",
      no_urut_dicetak: "",
      periode: getCurrentMonth(),
      judul: "",
      pesan: "",
    },
  });

  // const axiosInstance = useAxios();

  const options = [
    {
      id: 1,
      name: "Dosen",
    },
    {
      id: 2,
      name: "Staf",
    },
    {
      id: 3,
      name: "Part Time",
    },
  ];

  const keperluan = [
    {
      id: "Gaji",
      name: "Gaji",
    },
    {
      id: "Gaji 13",
      name: "Gaji 13",
    },
    {
      id: "IPK",
      name: "IPK",
    },
    {
      id: "BKT",
      name: "BKT",
    },
  ];

  const postItem = async (data) => {
    setPending(true);
    slipGajiAPI.postSlipGajiPreview(data, setPending).then((res) => {
      setData(res.data);
      setPending(false);
      setMode("preview");
    });
  };

  const getTemplate = () => {
    dokumenAPI.getTemplateSlip();
  };

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(postItem)}>
        <Controller
          name="keperluan"
          control={control}
          rules={{
            required: "Harap masukkan keperluan",
          }}
          render={({ field, fieldState }) => (
            <SelectionField
              label={"Keperluan"}
              options={keperluan}
              fieldState={fieldState}
              {...field}
              isRequired={true}
            />
          )}
        />
        <Controller
          name="file_gaji"
          control={control}
          rules={{
            required: "Harap upload file",
          }}
          render={({ field, fieldState }) => (
            <FileInputField
              label={"File"}
              fieldState={fieldState}
              {...field}
              isRequired={true}
              templateHandler={() => {
                getTemplate();
              }}
              downloadTemplateText="Template"
            />
          )}
        />
        <Controller
          name="no_urut_dicetak"
          control={control}
          rules={{
            required: "Harap masukkan nomor urut yang ingin dicetak",
          }}
          render={({ field, fieldState }) => (
            <InputField
              label={"No. Urut yang Dicetak"}
              className="me-2"
              fieldState={fieldState}
              {...field}
              tooltip={`
                jika ada beberapa, pisahkan dengan koma. 
                Misal 10, 29, 41. Untuk mencetak dalam jarak tertentu, 
                pisahkan dengan dash (-) misalnya: 1-5
              `}
              isRequired={true}
            />
          )}
        />
        <Controller
          name="periode"
          control={control}
          rules={{
            required: "Harap masukkan periode gaji",
          }}
          render={({ field, fieldState }) => (
            <MonthInputField
              className=""
              label={"Periode"}
              fieldState={fieldState}
              {...field}
              isRequired={true}
            />
          )}
        />
        <Controller
          name="judul"
          control={control}
          render={({ field, fieldState }) => (
            <InputField
              label={"Judul"}
              fieldState={fieldState}
              {...field}
              tooltip={`
                Contoh: Reivisi slip gaji.
                Jika kosong akan diisi default  
              `}
            />
          )}
        />
        <Controller
          name="pesan"
          control={control}
          render={({ field, fieldState }) => (
            <TextAreaField
              label={"Pesan"}
              fieldState={fieldState}
              {...field}
              tooltip={"Jika kosong akan diisi default"}
            />
          )}
        />
        <div className="d-flex justify-content-end mt-3">
          <Button
            color="primary"
            type="submit"
            className="me-2"
            disabled={!isValid || pending}
          >
            Preview
          </Button>
        </div>
      </Form>
    </Fragment>
  );
};

export default FormSlipGaji;
